export default __webpack_public_path__ + "static/media/banner-element.79660be3.svg";